import React, { FC } from 'react';
import Dashboard from './Dashboard';  
import { useTokens } from './hooks/useTokens';
import { domain, clientId, redirectUri } from './constants/config';
import login_image from './assets/login_image.png';

const App: FC=()=> 
{
  const { tokens, authCode, error, clearTokens} = useTokens({ clientId, redirectUri, domain });

  const handleLogin = () => {
    const loginUrl = `${domain}/login?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=email+openid+profile`;
    window.location.href = loginUrl;
  };

  const handleLogout = () => {
    clearTokens();
    window.location.href = `${domain}/logout?client_id=${clientId}&logout_uri=${redirectUri}`;
  };

  if (error) 
  {
    return <div>Error: {error}</div>;
  }

  return (
    <div className=" flex flex-col h-screen justify-center items-center">
      {authCode ? (
        tokens ? (
          <Dashboard token={tokens.id_token} logout={handleLogout}/>
        ) : (
          <div>Loading...</div>
        )
      ) : (
        <div className="flex flex-col items-center text-center">
          <div className="w-1/2 flex justify-center">
            <img src={login_image} alt="Dashboard" className="max-w-[90%] h-auto" />
          </div>
          <div className="w-1/2 flex flex-col items-center text-center px-4">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 86 20" className="w-[220px] py-3.5"><g clip-path="url(#wrkspot_svg__a)">
              <path fill="#A063A6" d="M23.464 15.298H20.7V4.042h2.644v2.393c.45-.882 1.66-2.393 3.36-2.393h.389v3.02c-.124-.059-.41-.097-.574-.097-1.865 0-3.052 1.334-3.052 2.275v6.058zM33.003 10.338l-1.312 1.235v3.725h-2.765V1.315L31.69 0v8.179l4.386-4.137h3.565l-4.712 4.47 4.999 6.786h-3.36zM9.8 4.983 6.974 15.298H3.776L0 1.315 2.793.002 5.56 11.298 8.305.002h3.156l2.725 11.315L16.971.002h2.91l-4.138 15.296h-3.197z"></path>
              <path fill="#13478F" d="M49.366 3.257c-.717-.275-1.824-.471-2.725-.471-1.7 0-2.397.549-2.397 1.393 0 .785.8 1.431 2.663 2.668 2.234 1.49 3.606 2.765 3.606 4.55 0 2.413-2.212 4.14-5.553 4.14-1.025 0-2.787-.237-3.523-.453l.041-2.568c.697.255 2.336.608 3.667.608 1.58 0 2.357-.764 2.357-1.609 0-.804-.82-1.49-2.683-2.706-2.684-1.764-3.546-2.942-3.546-4.61 0-1.96 1.557-3.824 5.37-3.824.943 0 2.008.157 2.765.353zM54.673 13.867v5.747h-2.767V4.042h2.624v1.53c1.127-1.176 2.787-1.902 4.732-1.902 3.402 0 5.982 2.649 5.982 5.963s-2.582 6.04-5.982 6.04c-1.841-.002-3.46-.707-4.589-1.806m3.832-.509c2.234 0 3.833-1.686 3.833-3.668s-1.599-3.706-3.833-3.706-3.913 1.726-3.913 3.687c0 1.98 1.68 3.687 3.913 3.687M79.793 9.67c0 3.433-2.889 6.198-6.822 6.198-3.914 0-6.823-2.765-6.823-6.197s2.91-6.197 6.823-6.197c3.933-.002 6.822 2.763 6.822 6.197m-10.736 0c0 2.177 1.66 3.943 3.914 3.943 2.273 0 3.933-1.785 3.933-3.942 0-2.176-1.66-3.943-3.933-3.943-2.256 0-3.914 1.765-3.914 3.943M84.524 6.277v9.021h-2.768V6.277h-1.475V4.042h1.475V1.315l2.767-.589v3.316H86v2.235z"></path>
              </g>
              <defs>
                <clipPath id="wrkspot_svg__a">
                  <path fill="#fff" d="M0 .193h86v19.614H0z"></path>
                </clipPath>
              </defs>
            </svg>
            <h2 className="py-4 font-sans font-medium text-[22px] leading-[26px] tracking-[.15px] text-[#2d2d2d]">DevOps Dashboard</h2>
            <button onClick={handleLogin} className="py-3 font-sans px-6 text-base font-medium text-white bg-[#4f46e5] rounded hover:bg-[#342ae1] transition">Sign In</button>
          </div>
        </div>
      )}
    </div>
  );

}

export default App;
